import { ArrowUpS16, UIText2 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './CollapseButton.css';
import { ICollapseButtonProps } from './types';

export const CollapseButton: React.VFC<ICollapseButtonProps> = props => {
  const { isCollapsed, onClick, collapsedText = 'Развернуть', uncollapsedText = 'Свернуть' } = props;

  return (
    <div className={cn(styles['container'], { [styles['container--collapsed']]: isCollapsed })} onClick={onClick}>
      <div data-testid="collapse-text" className={styles['collapse-text']}>
        <UIText2 color="primary_100">{isCollapsed ? collapsedText : uncollapsedText}</UIText2>
      </div>
      <div className={styles['collapse-arrow']}>
        <ArrowUpS16 color="primary_100" />
      </div>
    </div>
  );
};

CollapseButton.displayName = 'CollapseButton';
